import {Component, Input} from '@angular/core';
import {NgForm,FormBuilder} from '@angular/forms';
import { PaymentApi } from '../../../../../../assets/js/lb-sdk';


@Component({
  selector: 'ipay88-form',
  templateUrl: './ipay88-form.component.html',
  styleUrls: ['./ipay88-form.component.css'],
})
export class IPay88FormComponent {
    fieldNames = ['MerchantCode','MerchantID','MemberAccountID','Remark','UserContact','UserEmail',
        'UserName','Amount','ProdDesc','Signature' ];
    payForm = this.fb.group({
        MerchantCode: [''],MerchantID: [''], RefNo: [''], MemberAccountID: [''], Remark: [''],UserContact: [''],
        UserEmail: [''], UserName: [''], Amount: [''], ProdDesc: [''], Signature: ['']
     });
    paymentUrl: string;
    MerchantCode: string;
    constructor( 
        private fb: FormBuilder,
        private paymentApi: PaymentApi  ) {   }

    get f() { return this.payForm.controls; }

    onSubmit(f: NgForm, ev: any) {
        /*
        var payment = {"HOST":"https://sandbox.maxicare.com.ph/PaymentGateway/Epayment/entry.aspx",
            "request":{
                "ResponseURL":"http://ec2-13-250-182-34.ap-southeast-1.compute.amazonaws.com/api/Payments/ipay88",
                "MerchantCode":"PH00029",
                "MerchantID":"View01",
                "RefNo":"FR00000000041056",
                "MemberAccountID":"5678",
                "Remark":"Maxicare",
                "UserContact":"9175555555","UserEmail":"","UserName":"orvin","Amount":"15.00","ProdDesc":"Eready Advance","Signature":"5e88ed2cd024fc75f30e55f3f68296cd29cd9250c8728283c9d0f3a3da92739e"}};
        ev.target.action = payment.HOST;
        const { MerchantCode, MerchantID, RefNo, MemberAccountID, Remark,UserContact, UserEmail,
            UserName, Amount, ProdDesc, Signature } = payment.request;
        this.payForm.get('MerchantCode').setValue(MerchantCode);
        this.payForm.get('MerchantID').setValue(MerchantID);
        this.payForm.get('RefNo').setValue(RefNo);
        this.payForm.get('MemberAccountID').setValue(MemberAccountID);
        this.payForm.get('Remark').setValue(Remark);
        this.payForm.get('UserContact').setValue(UserContact);
        this.payForm.get('UserEmail').setValue(UserEmail);
        this.payForm.get('UserName').setValue(UserName);
        this.payForm.get('Amount').setValue(Amount);
        this.payForm.get('ProdDesc').setValue(ProdDesc);
        this.payForm.get('Signature').setValue(Signature);
        
        */
        ev.target.submit();

        return true;
    }
  
}